import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GridCell } from "@progress/kendo-react-grid";
export default class StatusComponent extends React.Component {
  localizedData = [
    { text: "Open", value: true },
    { text: "Closed", value: false },
  ];

  handleChange = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value.value,
    });

    if (this.props.field && this.props.field === this.props.dataItem.inEdit && this.props.dataItem.riskRegisterId) {
        let updateData = {
          ...this.props.dataItem, 'isClosed': e.target.value.value,
          
        }
        this.props.updateDropdownValue(updateData);
      }
  };

  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  }

  render() {
    const { dataItem, field } = this.props;
    let dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
        
        // dataValue=dataValue=="Open"?true:false;
    if (field && dataItem.inEdit === field) {
      return (
        <DropDownList
          style={ { width: "100px" } }
          onChange={ this.handleChange }
          value={ this.localizedData.find((c) => c.value === dataValue) }
          data={ this.localizedData }
          textField="text"
        />
      )
    }
    if (dataItem.inEdit !== field) {
      return (
        this.props.dataItem.role == "Standard User" || this.props.dataItem.role == "View Only" ? 
        (
          <td >
          {dataValue.toString() == "true" || dataValue.toString() == "Open" ?
            "Open"
            :
            "Closed"
          }
        </td>
        ):(
          <td onClick={ this.handleEditCell }>
          {dataValue.toString() == "true" || dataValue.toString() == "Open"?
            "Open"
            :
            "Closed"
          }
        </td>
        )
        
      )
    }
   
  }
}
